import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./Roadmap.css";
import { getAuthHeader } from "../../utils/auth";

const PROD_API_URL = "https://theqahubweb-production.up.railway.app";
const ENV_API_URL = (process.env.REACT_APP_API_URL || "").trim().replace(/\/$/, "");
const CURRENT_ORIGIN = typeof window !== "undefined" ? window.location.origin : "";
const NORMALIZED_ORIGIN = CURRENT_ORIGIN.includes("://www.theqahub.es")
  ? CURRENT_ORIGIN.replace("://www.", "://")
  : CURRENT_ORIGIN;
const getStoredApiUrl = () => {
  if (typeof window === "undefined") return "";
  try {
    return window.localStorage.getItem("theqahub_api_base") || "";
  } catch {
    return "";
  }
};
const STORED_API_URL = getStoredApiUrl();
const SHOULD_USE_ORIGIN = CURRENT_ORIGIN.includes("theqahub.es");
const API_URL = STORED_API_URL || (SHOULD_USE_ORIGIN ? NORMALIZED_ORIGIN : (ENV_API_URL || PROD_API_URL));

export default function RoadmapLayout() {
  const [heroTopic, setHeroTopic] = useState(null);
  const [progress, setProgress] = useState({});
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const ROADMAP_ORDER = [
    { id: "fundamentos", title: "Fundamentos QA" },
    { id: "manual", title: "Testing manual" },
    { id: "automation", title: "Automatización de software" },
    { id: "api", title: "API Testing" },
    { id: "cicd", title: "CI/CD para QA" },
    { id: "buenas", title: "Buenas prácticas" },
  ];

  const completedCount = ROADMAP_ORDER.filter(
    step => progress?.[step.id]?.completed
  ).length;

  const progressPercent = Math.round(
    (completedCount / ROADMAP_ORDER.length) * 100
  );

  const nextStep =
    ROADMAP_ORDER.find(step => !progress?.[step.id]?.completed) ||
    ROADMAP_ORDER[ROADMAP_ORDER.length - 1];

  const isTopicView = location.pathname.startsWith("/roadmap/");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_URL}/api/auth/roadmap`, {
          credentials: "include",
          headers: {
            ...getAuthHeader(),
          },
        });
        const data = await res.json().catch(() => ({}));
        if (res.ok) setProgress(data.roadmap || {});
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [location.pathname]);

  return (
    <div className="roadmap-page">
        <div className="dash-hero">
          <button
            className="dash-btn ghost roadmap"
            onClick={() => navigate(isTopicView ? "/roadmap" : "/dashboard")}
            style={{ marginBottom: 12 }}
            >
            ← {isTopicView ? "Volver al roadmap" : "Volver al dashboard"}
          </button>
          <div>
            <h1>{heroTopic?.title || "Ruta de estudio"}</h1>
            <p className="muted">
                {heroTopic?.subtitle || "Aprende, mejora y practica tus habilidades como QA paso a paso."}
            </p>

            <div className="dash-quick">
                <div className="quick-card">
                <div className="quick-title">{heroTopic?.metaLeftTitle || "Progreso general"}</div>
                <div className="quick-value">{heroTopic?.metaLeftValue ?? `${progressPercent}%`}</div>
                <div className="progress">
                    <div className="progress-bar" style={{ width: `${progressPercent}%` }} />
                </div>
                </div>

                <div className="quick-card">
                <div className="quick-title">{heroTopic?.metaMidTitle || "Siguiente paso"}</div>
                <div className="quick-value small">
                    {heroTopic?.metaMidValue ||
                    (completedCount === ROADMAP_ORDER.length ? "Ruta completada ✅" : nextStep.title)}
                </div>
                <div className="muted small">
                    {heroTopic?.metaMidDesc ||
                    (completedCount === ROADMAP_ORDER.length
                        ? "Has completado todos los paneles didácticos"
                        : "Continúa con el siguiente paso de la ruta")}
                </div>
                </div>

                <div className="quick-card">
                <div className="quick-title">{heroTopic?.metaRightTitle || "Objetivo"}</div>
                <div className="quick-value small">
                    {heroTopic?.metaRightValue || "Acabar todos los paneles didácticos"}
                </div>
                <div className="muted small">
                    {heroTopic?.metaRightDesc || "Ve paso a paso completando todos los niveles"}
                </div>
                </div>
            </div>
          </div>
        </div>

        <div className="roadmap-card">
            <Outlet context={{ progress, setProgress, loading, setHeroTopic }} />
        </div>

        {loading && <div className="muted" style={{ marginTop: 10 }}>Cargando progreso...</div>}
    </div>
  );
}
